import type { OverviewResponse } from "contracts/api/dashboard/responses";
import { Show } from "solid-js";
import { Portal } from "solid-js/web";
import type { PageMapLens } from "../../enums/map";
import { PAGE_MAP_LENS } from "../../enums/map";
import {
  pageDisplayLabel,
  rawPagePath,
} from "../pages/boundaries/page-label.parser";
import { estateTooltipPosition } from "./estateFormat";
import type { EstateNode, EstateViewport, ViewTransform } from "./estateTypes";
import { lensLabel, scoreLabel, stateLabel } from "./estateViewport";
import { pageContentFitnessScore } from "./scanModel";

export function EstateMapTooltip(props: {
  node: EstateNode;
  mapElement: SVGSVGElement | undefined;
  view: ViewTransform | null;
  site: OverviewResponse["site"];
  lens: PageMapLens;
  viewport: EstateViewport;
}) {
  const position = () =>
    estateTooltipPosition(
      props.node,
      props.mapElement,
      props.view,
      props.viewport,
    );
  return (
    <Portal>
      <div
        class={`signal-estate-tooltip is-${position().placement}`}
        style={{
          left: `${position().left}px`,
          top: `${position().top}px`,
          width: `${position().width}px`,
        }}
      >
        <strong>{pageDisplayLabel(props.node.page, props.site)}</strong>
        <span class="mono">{rawPagePath(props.node.page)}</span>
        <dl>
          <div>
            <dt>Content Fitness</dt>
            <dd>{scoreLabel(pageContentFitnessScore(props.node.page))}</dd>
          </div>
          <div>
            <dt>Agent diagnostic</dt>
            <dd>
              {scoreLabel(props.node.page.agentScore, PAGE_MAP_LENS.AGENT)}
            </dd>
          </div>
          <div>
            <dt>Linked issues</dt>
            <dd>{props.node.issueCount}</dd>
          </div>
          <div>
            <dt>{lensLabel(props.lens)} state</dt>
            <dd>{stateLabel(props.node.state, props.lens)}</dd>
          </div>
        </dl>
        <Show when={props.node.important}>
          <em>Linked to a priority issue</em>
        </Show>
      </div>
    </Portal>
  );
}
